import { Tag } from "../Tag";

export class Label extends Tag {
    public getTagName() {
        return "label";
    }
}
